import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import map from 'lodash/map';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';

import useVerifyOrgRole from '../../../store/hooks/useVerifyOrgRole';
import { getImages, postImage } from '../../../store/images/_images';
import ImageContainer from './ImageContainer';
import NewImageContainer from './NewImageContainer';

function Images(props) {
  const { resourceId, orgId } = props;

  const dispatch = useDispatch();
  const fileInputRef = useRef(null);
  const isOrgEditor = useVerifyOrgRole(orgId, 1);

  const images = useSelector((state) => state.images.data);

  const [imageFile, setImageFile] = useState(null);
  const [imageBlobUrl, setImageBlobUrl] = useState(null);
  const [imageFilename, setImageFilename] = useState('');
  const [imageName, setImageName] = useState('');
  const [imageFileExt, setImageFileExt] = useState('');

  useEffect(() => {
    if (resourceId) {
      dispatch(getImages(resourceId));
    }
  }, [resourceId, dispatch]);

  useEffect(() => {
    const lastDotIndex = imageFilename.lastIndexOf('.');
    const [name, ext] = [
      imageFilename.slice(0, lastDotIndex),
      imageFilename.slice(lastDotIndex),
    ];

    setImageName(name);
    setImageFileExt(ext);
  }, [imageFilename]);

  const handleSave = async (e) => {
    e.preventDefault();
    const filename = imageName + imageFileExt;
    const image = imageFile;

    setImageFile(null);
    setImageFilename('');
    setImageBlobUrl(null);

    await dispatch(
      postImage({
        resource_id: resourceId,
        image,
        filename,
      })
    );

    dispatch(getImages(resourceId));
  };

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFileUpload = (e) => {
    e.preventDefault();
    let _imageFile = null;

    if (e.dataTransfer) {
      _imageFile = e.dataTransfer.files[0];
    } else if (e.target.files) {
      _imageFile = e.target.files[0];
    }

    setImageFile(_imageFile);
    setImageFilename(_imageFile.name);
    setImageBlobUrl(URL.createObjectURL(_imageFile));
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        {imageBlobUrl ? (
          <NewImageContainer
            handleSave={handleSave}
            image={imageBlobUrl}
            imageName={imageName}
            imageFileExt={imageFileExt}
            setImage={setImageBlobUrl}
            setImageName={setImageName}
            setImageFilename={setImageFilename}
            isNewImage
          />
        ) : isOrgEditor ? (
          <Card raised sx={{ p: 2 }}>
            <Box
              onDrop={handleFileUpload}
              onDragOver={(e) => e.preventDefault()}
              sx={{
                borderColor: (theme) => theme.palette.grey[500],
                borderRadius: '10px',
                borderStyle: 'dashed',
                width: '100%',
                height: '15rem',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                }}>
                <span>Drag and drop images or </span>
                <Button
                  type='file'
                  sx={{ ml: 1 }}
                  variant='contained'
                  onClick={handleButtonClick}>
                  Browse Files
                </Button>
                <input
                  id='image'
                  type='file'
                  accept='.png, .jpg, .jpeg, .svg, .webp, .gif'
                  ref={fileInputRef}
                  onChange={handleFileUpload}
                  style={{ display: 'none' }}
                />
              </div>
            </Box>
          </Card>
        ) : null}
      </Grid>

      {map(images, (_image) => {
        return (
          <Grid item xs={12} key={_image}>
            <ImageContainer resourceId={resourceId} imageFilename={_image} />
          </Grid>
        );
      })}
    </Grid>
  );
}

export default Images;
